module.exports = __webpack_public_path__ + "img/Image.15208c64.png";